<template>
  <div class="seg" role="tablist">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      role="tab"
      :class="{ on: opt.value === value }"
      :aria-selected="opt.value === value"
      @click="$emit('input', opt.value)"
    >
      {{ opt.label }}
      <span v-if="opt.count != null" class="ct">{{ opt.count }}</span>
    </button>
  </div>
</template>

<script>
// Segmented control (.seg) — filtros de lista. v-model compatível.
export default {
  name: "ClinicSeg",
  props: {
    value: { type: [String, Number], default: null },
    options: { type: Array, required: true } // [{ value, label, count? }]
  }
};
</script>
